import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/providers/apiService/api.service';

@Component({
  selector: 'app-hospital-list',
  templateUrl: './hospital-list.component.html',
  styleUrls: ['./hospital-list.component.scss'],
})
export class HospitalListComponent implements OnInit {
  hospitals: any[];
  hasSkelton = true;
  filter: any;
  constructor(private apiService: ApiService, public modalController: ModalController) { }

  ngOnInit() { this.getdoctorList(); }
  getdoctorList() {
    this.apiService.post('hospital-list', {}).subscribe(
      (res) => {
        this.hasSkelton = false;
        if (res.error === false) {
          this.hospitals = res.data.hospitals;
        } else {
          this.hasSkelton = false;
        }
      },
      (err) => {
        this.hasSkelton = false;
      }
    );
  }
  goBack() {
    this.modalController.dismiss();
  }
  selectHospital(hospital: any) {
    if (hospital === '') {
      hospital = { id: '', hospital: '' };
    }

    this.modalController.dismiss(hospital);
  }

}
